import { mobileOS } from '@va/constants';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import {
  getMobileOperatingSystem,
  initializeFlagsmith,
  isInWebApp,
  logVersion,
  setDefaultTheme,
} from '@va/util/helpers';
import { createRoot } from 'react-dom/client';
import 'react-loading-skeleton/dist/skeleton.css';
import App from './app/app';
import './index.css';
import { registerOfflineWorker, unregisterAndClearCache } from './registerServiceWorker';

// if (process.env.NODE_ENV === 'development') {
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React, {
//     trackAllPureComponents: true,
//     collapseGroups: true
//   });
// }

// initializeSentry();
logVersion();
setDefaultTheme();

const flagsmithApiUrl = (() => {
  // Make sure flagsmith has the same api url as the dashboard in case of the old domain - visitor-analytics.io
  const isHostedOnOldDomains = ['app.visitor-analytics.io', 'app-canary.visitor-analytics.io'].includes(
    window.location.host,
  );

  if (isHostedOnOldDomains || isUserLoggedInWithCustomUrl()) return window.location.origin;
})();

initializeFlagsmith(flagsmithApiUrl);

const root = createRoot(document.getElementById('root')!);
root.render(<App />);

const os = getMobileOperatingSystem();
if (isInWebApp() && (os === mobileOS.android || os === mobileOS.ios)) {
  registerOfflineWorker();
} else {
  unregisterAndClearCache();
}
